import React, { useEffect, useState } from "react";
import classes from "../style/Style.module.css";
import "../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  ROUTE_ACCOUNT_TYPE,
  ROUTE_DEXTER_SCANNING2,
  ROUTE_MOBILE_VERIFICATION,
} from "../Routes";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../libs/axiosConfig";
import Toast from "../Components/ToastMsg/Toast";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import { selectPhoneNumber } from "../Store/MobileSlice";
import { selectPanNumber } from "../Store/panNumberSlice";
// import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
import axiosAPI from "axios";
import { selectBankName } from "../Store/UserBankSlice";
import NewDexterLogo from "../Images/NewDexterLogo.svg";
import LogoutModal from "../Components/LogoutModal";

const Bank = () => {
  const Navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [selectedType, setSelectedType] = useState("Savings");
  const [ifscCode, setIFSCCode] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const phoneNumber = useSelector(selectPhoneNumber);
  // const refreshToken = useSelector(selectRefreshToken);
  const UserbankName = useSelector(selectBankName);
  const location = useLocation();
  const { bankDetails } = location.state || {};
  const [showModal, setShowModal] = useState(false);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);
  console.log(bankDetails);
  console.log(UserbankName.bankName);

  const panNumber = useSelector(selectPanNumber);

  const handleBankAccountNumberChange = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    setBankAccountNumber(input);
  };

  const handleTypeClick = (type) => {
    setSelectedType(type);
  };

  const handleIFSCCodeChange = (e) => {
    const input = e.target.value.toUpperCase();
    setIFSCCode(input);
  };

  const handleBankAccountNumberClear = () => {
    setBankAccountNumber("");
  };

  const handleIFSCCodeClear = () => {
    setIFSCCode("");
  };
  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const HandleSubmit = async () => {
    try {
      if (!bankAccountNumber || !ifscCode || !selectedType) {
        setFormErrors({
          bankAccountNumber: !bankAccountNumber,
          ifscCode: !ifscCode,
          selectedType: !selectedType,
        });
        Toast.error("Please fill the details");
        setIsFormValid(false);
        return;
      }
      setApiCallsInProgress(apiCallsInProgress + 1);

      const firstApiURL = `https://ifsc.razorpay.com/${ifscCode}`;
      const firstApiResponse = await axios.get(firstApiURL);
      const { BANK, ADDRESS } = firstApiResponse.data;

      let accountType = selectedType;

      if (selectedType === "Savings") {
        accountType = "SB";
      } else if (selectedType === "Current") {
        accountType = "CA";
      }
      // Check the length of the branch address and trim if necessary
      let branchAddress = ADDRESS;
      if (branchAddress && branchAddress.length > 120) {
        branchAddress = branchAddress.substring(0, 120); // Take the first 120 characters
      }


      if (BANK) {
        const secondApiURL =
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
        const secondApiResponse = await axios.post(
          secondApiURL,
          {
            CustomerKycDetails: {
              request_type: "post",
              mobileNumber: phoneNumber,
              pan: panNumber,
              bankAccountNumber: bankAccountNumber,
              bankIfscCode: ifscCode,
              bankAccountType: accountType,
              bankBranchAddress: branchAddress,
              bankBranchName: firstApiResponse.data.BRANCH,
              bankName: UserbankName.bankName,
              bankCodeNSE: bankDetails.bankCode,
              bankCodeBillDesk: bankDetails.billdeskCode,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (secondApiResponse.data.statusCode === 200) {
          setApiCallsInProgress(apiCallsInProgress + 1);

          // const thirdApiURL =
          //   "https://partnerapp.ambrela.money/api/AddCustomerKycDetails";
          // const thirdApiResponse = await axios.post(
          //   thirdApiURL,
          //   {
          //     bankAccountNumber: bankAccountNumber,
          //     bankIfscCode: ifscCode,
          //     bankAccountType: accountType,
          //     bankBranchAddress: firstApiResponse.data.ADDRESS,
          //     bankBranchName: firstApiResponse.data.BRANCH,
          //     bankName: UserbankName.bankName,
          //     bankCodeNSE: bankDetails.bankCode,
          //     bankCodeBillDesk: bankDetails.billdeskCode,
          //   },
          //   {
          //     headers: {
          //       Authorization: `Bearer ${storedToken}`,
          //     },
          //   }
          // );

          const fifthApiURL =
            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
          const fifthApiResponse = await axios.post(
            fifthApiURL,
            {
              VerifyBankAccount: {
                mobileNumber: phoneNumber,
                pan: panNumber,
              },
            },
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              },
            }
          );
          const responsefullname = fifthApiResponse.data.data.full_name;
          console.log(responsefullname);
          // const dexterrbankverification =
          //   "https://partnerapp.ambrela.money/api/bank-verification";
          // const dexterrbankverificationresponse = await axiosAPI.post(
          //   dexterrbankverification,
          //   {},
          //   {
          //     headers: {
          //       Authorization: `Bearer ${storedToken}`,
          //     },
          //   }
          // );

          const secondApiURL =
            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
          const secondApiResponse = await axios.post(
            secondApiURL,
            {
              CustomerKycDetails: {
                request_type: "post",
                mobileNumber: phoneNumber,
                pan: panNumber,

                bankAccountHolderName: responsefullname,
              },
            },
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              },
            }
          );

          // const thirdApiURL =
          //   "https://partnerapp.ambrela.money/api/AddCustomerKycDetails";
          // const thirdApiResponse = await axios.post(
          //   thirdApiURL,
          //   {
          //     bankAccountHolderName: responsefullname,
          //   },
          //   {
          //     headers: {
          //       Authorization: `Bearer ${storedToken}`,
          //     },
          //   }
          // );
          if (
            fifthApiResponse.data.status_code === 200 &&
            fifthApiResponse.data.data.account_exists === true &&
            fifthApiResponse.data.message_code === "success" &&
            fifthApiResponse.data.data.full_name !== ""
          ) {
            setApiCallsInProgress(apiCallsInProgress + 1);

            Navigate(ROUTE_DEXTER_SCANNING2, {
              state: {
                BankVerificationMsg: "Your Bank Account Verification Success.",
              },
            });
            console.log("checking this condition");
          } else {
            setApiCallsInProgress(apiCallsInProgress + 1);

            Navigate(ROUTE_DEXTER_SCANNING2, {
              state: {
                BankVerificationMsg:
                  "Your Bank Account Verification Failed. Please add another valid Bank Account details.",
              },
            });
            console.log("else condition is working");
          }
        } else {
          setApiCallsInProgress(apiCallsInProgress + 1);

          setIsFormValid(false);
          Toast.error(
            secondApiResponse.data.message +
            " " +
            secondApiResponse.data.errorMessage
          );
        }
      } else {
        setIsFormValid(false);
        Toast.error("Bank details not available.");
      }
    } catch (error) {
      setIsFormValid(false);
      Toast.error(
        error.response.data.errorMessage + " " + error.response.data.message ||
        "Error"
      );
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="bank_Main_Container">
      <div className="bankscreen_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="Kyc_Proceed_Container">
        <p className="Input_Heading_text">Enter bank details.</p>
        <span className="Input_Sub_heading">
          To facilitate complete identity verification and comply with KYC
          regulations, please enter your bank account details.
        </span>

        {/* Bank Account Number Input */}
        <div className="Input_Filed_Box">
          <span className="Enter_mobile_text">
            Enter bank account number
          </span>
          <div className="Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.bankAccountNumber ? classes.Error : ""
                }`}
              value={bankAccountNumber}
              onChange={handleBankAccountNumberChange}
            />

            <button
              className="Cross_button"
              onClick={handleBankAccountNumberClear}
            />
          </div>
        </div>

        {/* IFSC Code Input */}
        <div className="Input_Filed_Box">
          <span className="Enter_mobile_text">
            Enter bank IFSC code
          </span>
          <div className="Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.ifscCode ? classes.Error : ""
                }`}
              value={ifscCode}
              onChange={handleIFSCCodeChange}
            />

            <button
              className={classes.Cross_button}
              onClick={handleIFSCCodeClear}
            />
          </div>
        </div>

        {/* {Account type} */}
        <div className="Account_type_container">
          <p className="Account_type_text">Account type</p>
          <div className="Select_Bank_Ac">
            <div
              className={`${classes.Rounded_CheckBox_Container} ${selectedType === "Savings" ? classes.Active : ""
                }`}
              onClick={() => handleTypeClick("Savings")}
            >
              <button
                className={`${classes.AccountCheck_Input} ${selectedType === "Savings" ? classes.ActiveButton : ""
                  }`}
              />
              <span
                className={`${classes.Bank_type_text} ${selectedType === "Savings" ? classes.ActiveText : ""
                  }`}
              >
                Savings
              </span>
            </div>
            <div
              className={`${classes.Rounded_CheckBox_Container} ${selectedType === "Current" ? classes.Active : ""
                }`}
              onClick={() => handleTypeClick("Current")}
            >
              <button
                className={`${classes.AccountCheck_Input} ${selectedType === "Current" ? classes.ActiveButton : ""
                  }`}
              />
              <span
                className={`${classes.Bank_type_text} ${selectedType === "Current" ? classes.ActiveText : ""
                  }`}
              >
                Current
              </span>
            </div>
          </div>
        </div>

        <button className="Submit_button" onClick={HandleSubmit}>
          {" "}
          Submit{" "}
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
    </div>
  );
};

export default Bank;
